import { render, staticRenderFns } from "./DevicesPage.vue?vue&type=template&id=b23178f0&"
import script from "./DevicesPage.vue?vue&type=script&lang=js&"
export * from "./DevicesPage.vue?vue&type=script&lang=js&"
import style0 from "./DevicesPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports